/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { ReactComponent as RightArrow } from "cms/assets/icons/arrow-right.svg";

const IconLinkTabNav = (props) => {
    const { tabs, selectTab } = props;

    return (
        <div className="icon-link-tab-nav-wrapper">
            {tabs?.map((tab, index) => {
                const isActiveTab = tab?.isVisible ?? false;
                return (
                    <button
                        key={tab?.guid}
                        data-tab-index={index}
                        role="tab"
                        tabIndex={index}
                        aria-selected={isActiveTab}
                        aria-controls={tab?.guid}
                        id={tab?.guid}
                        onClick={(event) => selectTab(event, tab?.guid)}
                        className={isActiveTab ? "active" : ""}
                    >
                        <span>{tab?.title}</span>
                        {isActiveTab && <RightArrow alt="right-arrow" />}
                    </button>
                );
            }
            )}
        </div>
    );
};

IconLinkTabNav.displayName = "IconLinkTabNav";
export { IconLinkTabNav }; 